import React from 'react';
import PropTypes from 'prop-types';
import {
  MoreVertical,
  Share2,
  Copy,
  DownloadCloud,
  Trash2,
  Send,
  Calendar,
  X,
  Paperclip,
  Info,
  Video,
  Layout,
  Lock,
  Search,
  Settings,
  Image,
  Save,
  User,
  ChevronDown,
  ChevronRight,
  Menu,
  HelpCircle,
  RotateCw,
  ArrowUpLeft,
  Edit3,
  Eye,
  Type,
  Square,
  Mail,
  Phone,
  MapPin,
  UploadCloud,
  ArrowLeft,
  ArrowRight,
  Link2,
  Grid,
  FilePlus,
  Minus,
  CheckCircle
} from 'react-feather';

import { Amazon, Youtube, Google, Facebook, Twitter } from '../SocialMediaElement/SocialMediaIcon';

import { StyledSvgIcon } from './styles';

const IconMap = {
  MoreVertical,
  Share2,
  Copy,
  DownloadCloud,
  Trash2,
  Send,
  Calendar,
  X,
  Paperclip,
  Info,
  Video,
  Layout,
  Lock,
  Search,
  Settings,
  Image,
  Save,
  User,
  ChevronDown,
  ChevronRight,
  Menu,
  HelpCircle,
  RotateCw,
  ArrowUpLeft,
  Edit3,
  Eye,
  Type,
  Square,
  Mail,
  Phone,
  MapPin,
  UploadCloud,
  ArrowLeft,
  ArrowRight,
  Link2,
  Grid,
  FilePlus,
  Minus,
  CheckCircle,
  Amazon,
  Youtube,
  Google,
  Facebook,
  Twitter
};

export const VpIcon = ({ icon = '', size = '', children, ...rest }) => {
  if (icon) {
    const IconComponent = IconMap[icon];

    return (
      <StyledSvgIcon size={size} {...rest}>
        <IconComponent />
      </StyledSvgIcon>
    );
  }

  return (
    <StyledSvgIcon size={size} {...rest}>
      {children}
    </StyledSvgIcon>
  );
};

VpIcon.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default VpIcon;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpIcon/VpIcon.jsx